import Http from '@/api/http.js'
import Segment from './supplier/Segment'
import Brand from './supplier/Brands'

export default {
  ...Segment,
  ...Brand,

  index(type, filter) {
    return Http.get(`/${type}`, {params: {...filter}})
  },
  indexByModel(model, model_id, type) {
    return Http.get(`/${model}/${model_id}/${type}`)
  },
  createProduct(newProduct) {
    return Http.post(`/products`, {
      product: {
        name: newProduct.name,
        status_id: 1,
        segment_id: newProduct.segment_id,
        brand_id: newProduct.brand_id,
        comissions_attributes: newProduct.comissions_attributes,
      }
    })
  },
  createMarket(newMarket) {
    return Http.post(`/pickup_locations`, {
      pickup_location: {
        name:         newMarket.name,
        brand_id:        newMarket.brand,
        fantasyName:  newMarket.fantasyName,
        corportaName: newMarket.corportaName,
        CNPJ:         newMarket.CNPJ.toString().replace(/[\W]/g, ""),
        status_id:    newMarket.status_id,
        'address_attributes': newMarket.address_attributes,
        'product_pickup_locations_attributes': newMarket.product_pickup_locations_attributes,
      }
    })
  },
  createPrices(newPrice) {
    return Http.post(`/product_prices`, {
      product_prices: 
      newPrice
    })
  },
  
  updateProduct(supplier_id, updateSupplier) {
    return Http.put(`/suppliers/2/${supplier_id}`, {
      product: {
        name: updateSupplier.name,
      }
    })
  },
  updateMarket(supplier_id, updateSupplier) {
    return Http.put(`/suppliers/3/${supplier_id}`, {
      market: {
        name: updateSupplier.name,
      }
    })
  },
  updatePrice(supplier_id, updateSupplier) {
    return Http.put(`/suppliers/4/${supplier_id}`, {
      price: {
        name: updateSupplier.name,
      }
    })
  },

  //PICKUPLOCATOINS
    showPL(id){
      return Http.get(`/pickup_locations/${id}`)
    },

    updatePLInfo (params){
      return Http.put(`/pickup_locations/${params.id}`, {
        pickup_location: {...params}
      })
    },

    updatePLAddress (params){
      return Http.put(`/pickup_locations/${params.id}`, {
        pickup_location: {...params}
      })
    },
    updatePLProducts (params){
      return Http.put(`/pickup_locations/${params.id}`, {
        pickup_location: {...params}
      })
    },
  //

  //PPL
    updatePPL_Prices(params){
      return Http.put(`/product_pickup_locations/${params.id}`, {
        product_pickup_location: {...params}
      })
    },
    updatePPL_Products(params){
      return Http.put(`/product_pickup_locations/${params.id}`, {
        product_pickup_location: {...params}
      })
    },

  //PRODUCTS ONLY
    updateOnlyProduct(params){
      console.log('updateOnlyProduct', params)
      return Http.put(`/products/${params.id}`, {
        product: { ...params }
      })
    },

  show(params) {
    return Http.get(`/${params.type}/${params.id}`)
  },

}